export const exerciseDetailsPaperListStyle = { borderRadius: 2 };

export const exerciseDetailsListSubheaderStyle = { borderTopLeftRadius: 4, borderTopRightRadius: 4 };

export const exerciseDetailsListStyle = { mt: 0, pt: 0 };

export const exerciseDetailsPaperListElevation = 8;
